export default __webpack_public_path__ + "static/media/fxdx_black.38ad4439.svg";